import { captureException } from 'lib/reporting';

/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore return never so this statically checks exhaustiveness, but don't
// throw an error so render doesn't break.
export function assertNever(x: never): never {
  const dump = typeof x === 'object' ? JSON.stringify(x) : x;
  captureException(new TypeError(`assertNever non-exhaustive match: ${dump}`));
}

export function assertNeverAndThrow(x: never): never {
  const dump = typeof x === 'object' ? JSON.stringify(x) : x;
  throw new TypeError(`assertNever non-exhaustive match: ${dump}`);
}

export type ValueOf<T> = T[keyof T];
export type Nullable<T> = { [P in keyof T]: T[P] | null };
